import React from 'react';
import classNames from "classnames";
import SelectField from 'components/SelectField';
import {productType} from 'propTypes/products';
import PropTypes from 'prop-types';

import {gettext} from 'utils/text';
import {QUALITY_CONTROL} from 'constants/production';


const ProductionQualityControlDecision = (
    {
        title, product, values, errors, touched,
        handleChange, handleBlur, setFieldValue,
    },
) => (
    <div>
        <h5>{title}</h5>
        <div className="form-group">
            {product.order.quality_check_required && (
                <div className="custom-control custom-radio">
                    <input
                        type="radio"
                        className={classNames(
                            'custom-control-input',
                            {'is-invalid': touched.action && errors.action},
                        )}
                        name="action"
                        id="action-approve"
                        data-testid="approve"
                        value={QUALITY_CONTROL.APPROVE}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        checked={values.action === QUALITY_CONTROL.APPROVE}
                        required
                    />
                    <label htmlFor="action-approve" className="custom-control-label">
                        {gettext("Approve")}
                    </label>
                </div>
            )}
            <div className="custom-control custom-radio">
                <input
                    type="radio"
                    className={classNames(
                        'custom-control-input',
                        {'is-invalid': touched.action && errors.action},
                    )}
                    name="action"
                    id="action-reject"
                    data-testid="reject"
                    value={QUALITY_CONTROL.REJECT}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.action === QUALITY_CONTROL.REJECT}
                    required
                />
                <label htmlFor="action-reject" className="custom-control-label">{gettext("Reject")}</label>
            </div>
            {touched.action && errors.action && <div className="text-danger">{errors.action}</div>}
        </div>

        {values.action === QUALITY_CONTROL.REJECT && (
            <SelectField
                name="nextStatus"
                error={errors.nextStatus}
                touched={touched.nextStatus}
                label={gettext("Status to push back to")}
                options={product.previous_statuses}
                onBlur={handleBlur}
                onChange={setFieldValue}
                value={values.nextStatus}
            />
        )}

        <div className="form-group">
            <label htmlFor="comment">{gettext("Comment")}</label>
            <textarea
                className={classNames(
                    'form-control',
                    {'is-invalid': touched.comment && errors.comment},
                )}
                name="comment"
                id="comment"
                {...(values.action === QUALITY_CONTROL.REJECT && {required: true})}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.comment}
            />
            {touched.comment && errors.comment && <div className="invalid-feedback">{errors.comment}</div>}
        </div>
    </div>
);


ProductionQualityControlDecision.propTypes = {
    title: PropTypes.string.isRequired,
    product: productType.isRequired,
    values: PropTypes.shape({
        action: PropTypes.string,
        comment: PropTypes.string.isRequired,
        nextStatus: PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
    }).isRequired,
    errors: PropTypes.shape({
        comment: PropTypes.string,
    }).isRequired,
    touched: PropTypes.shape({
        comment: PropTypes.bool,
    }).isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
};


export default ProductionQualityControlDecision;



// WEBPACK FOOTER //
// ./src/components/ProductionQualityControlDecision/ProductionQualityControlDecision.js